import React from 'react'

const TrialItem = () => {
  return (
    <div>TrialItem</div>
  )
}

export default TrialItem